import React, { useContext } from 'react';
import {
	CircularProgress,
	FormControl,
	FormHelperText,
	MenuItem,
	TextField,
} from '@material-ui/core';
import { getVestibularOptions } from 'helpers/options';
import QuestionContext from '../../screens/ListarQuestoes/providers/QuestionProvider';

interface Props {
	name: string;
	value: string;
	onChange: any;
	error?: boolean | undefined;
	helperText?: string | false | undefined;
	disabled?: boolean;
}

const SelectVestibular: React.FC<Props> = ({
	name,
	value,
	onChange,
	error,
	helperText,
	disabled = false,
}) => {
	const { data, loading } = useContext(QuestionContext);

	if (loading) {
		return <CircularProgress />;
	}

	return (
		<FormControl
			variant="outlined"
			error={error}
			className="mr-2"
			style={{ minWidth: '60%', maxWidth: '100%' }}
		>
			<TextField
				fullWidth
				variant="outlined"
				label="Escolha o Vestibular"
				InputLabelProps={{ shrink: true }}
				name={name}
				select
				value={value}
				onChange={onChange}
				disabled={disabled}
			>
				{getVestibularOptions({ vestibulares: data.vestibulares })
					.slice(1)
					.map(option => (
						<MenuItem key={option.value} value={option.value}>
							{option.label}
						</MenuItem>
					))}
			</TextField>
			<FormHelperText>{helperText}</FormHelperText>
		</FormControl>
	);
};

export default SelectVestibular;
